export const ORDER_BUNDLE_DESCRIPTION =
  "Use the summary below to save your order as an estimate or place the order.";
export const CHECKOUT = "Checkout";
// export const SAVED_FOR_LATER = "Saved for later Items";
